import {
    CoreApiFilterObject,
    FILTER_TYPES,
} from '@/coreApi/filters/coreApiFilterObject'

const FILTER_ID_PAGE_DATE_FILTER = 'pwr'

const coreApiPageFilters = [
    {
        title: 'Week',
        key: 'wr',
        field_name: 'Week',
        data: [],
    },
]

// eslint-disable-next-line import/prefer-default-export
export const coreApiPageWeekFilterObject = new CoreApiFilterObject(FILTER_ID_PAGE_DATE_FILTER, FILTER_TYPES.WEEK_INDICATOR, coreApiPageFilters)
